import styled from '@xstyled/styled-components';

/**
 * Shared chrome for EDS CAT HUD icon buttons (Settings / Help / Feedback).
 * Figma: 38×38, radius 8, bg rgba(46,46,46,0.6).
 *
 * CAT-1244 / WCAG 1.4.12: keep min-* + overflow:visible so user text-spacing
 * styles cannot clip the chrome. Square width/height + grid/font-size:0 keep
 * icons centered at 400% zoom / compact HUD (320×265).
 */
export const EdsHudButton = styled.button`
  position: relative;
  background: rgba(46, 46, 46, 0.6);
  box-sizing: border-box;
  width: 38px;
  height: 38px;
  min-width: 38px;
  min-height: 38px;
  flex-shrink: 0;
  overflow: visible;
  border-radius: md;
  border: none;
  display: grid;
  place-items: center;
  padding: 0;
  margin: 0;
  font-size: 0;
  line-height: 0;
  color: ${p => p.theme.colors.white};
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover:not(:disabled) {
    background-color: color-mix(in srgb, rgba(46, 46, 46, 0.6) 70%, white);
  }

  &:active:not(:disabled) {
    background-color: color-mix(in srgb, rgba(46, 46, 46, 0.6) 70%, black);
  }

  &:focus {
    outline: 2px solid var(--color-focus-ring);
    outline-offset: 2px;
  }

  &:focus::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: md;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid var(--color-focus-ring-inner);
    pointer-events: none;
  }

  /* @media ((max-width: 580px) and (max-height: 300px)) {
    width: 28px;
    height: 28px;
    min-width: 28px;
    min-height: 28px;
  } */
`;
